import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, list_type, anonRecord_type, record_type, int32_type, string_type, union_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Page$reflection as Page$reflection_1 } from "../Subscriptions/Model.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Details", "Subscriptions", "Invoices", "Notes", "Agreements", "CustomerFees", "History", "WholesaleRGU", "NumberDirectory", "Attributes", "MissingInvoiceeNr", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.Invoicee.Model.Page", [], Page, () => [[["Item", class_type("System.Int64")]], [["Item1", class_type("System.Int64")], ["Item2", Page$reflection_1()]], [["Item", class_type("System.Int64")]], [["Item", class_type("System.Int64")]], [["Item", class_type("System.Int64")]], [["Item", class_type("System.Int64")]], [["Item", class_type("System.Int64")]], [["Item", class_type("System.Int64")]], [["Item", class_type("System.Int64")]], [["Item", class_type("System.Int64")]], [], []]);
}

export class Modal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CreateFee", "SendSMS", "CreateSubscription", "DeleteInvoicee", "PauseTerminationProcess", "Nothing"];
    }
}

export function Modal$reflection() {
    return union_type("Containers.Invoicee.Model.Modal", [], Modal, () => [[], [], [], [], [], []]);
}

export class Note extends Record {
    constructor(Username, Timestamp, Text$, InvoiceeNoteNr) {
        super();
        this.Username = Username;
        this.Timestamp = Timestamp;
        this.Text = Text$;
        this.InvoiceeNoteNr = (InvoiceeNoteNr | 0);
    }
}

export function Note$reflection() {
    return record_type("Containers.Invoicee.Model.Note", [], Note, () => [["Username", string_type], ["Timestamp", class_type("System.DateTime")], ["Text", string_type], ["InvoiceeNoteNr", int32_type]]);
}

export class PdfDownloadDTO extends Record {
    constructor(Description) {
        super();
        this.Description = Description;
    }
}

export function PdfDownloadDTO$reflection() {
    return record_type("Containers.Invoicee.Model.PdfDownloadDTO", [], PdfDownloadDTO, () => [["Description", anonRecord_type(["DownloadedTemplate", string_type], ["File", string_type])]]);
}

export class ContractHistory extends Record {
    constructor(ClientNr, ContractNr, EventName, EventArgsJson, AtUtc) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.EventName = EventName;
        this.EventArgsJson = EventArgsJson;
        this.AtUtc = AtUtc;
    }
}

export function ContractHistory$reflection() {
    return record_type("Containers.Invoicee.Model.ContractHistory", [], ContractHistory, () => [["ClientNr", int32_type], ["ContractNr", int32_type], ["EventName", string_type], ["EventArgsJson", string_type], ["AtUtc", class_type("System.DateTime")]]);
}

export class NoteResponse extends Record {
    constructor(Notes, ContractHistory) {
        super();
        this.Notes = Notes;
        this.ContractHistory = ContractHistory;
    }
}

export function NoteResponse$reflection() {
    return record_type("Containers.Invoicee.Model.NoteResponse", [], NoteResponse, () => [["Notes", list_type(Note$reflection())], ["ContractHistory", list_type(ContractHistory$reflection())]]);
}

export class CreateInvoiceeNote extends Record {
    constructor(Text$) {
        super();
        this.Text = Text$;
    }
}

export function CreateInvoiceeNote$reflection() {
    return record_type("Containers.Invoicee.Model.CreateInvoiceeNote", [], CreateInvoiceeNote, () => [["Text", string_type]]);
}

export class NoteKind extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Note", "ContractHistory"];
    }
}

export function NoteKind$reflection() {
    return union_type("Containers.Invoicee.Model.NoteKind", [], NoteKind, () => [[["Item", Note$reflection()]], [["Item", ContractHistory$reflection()]]]);
}

export class InvoiceeCurrentState extends Record {
    constructor(CurrentState) {
        super();
        this.CurrentState = CurrentState;
    }
}

export function InvoiceeCurrentState$reflection() {
    return record_type("Containers.Invoicee.Model.InvoiceeCurrentState", [], InvoiceeCurrentState, () => [["CurrentState", option_type(string_type)]]);
}

export class TemplateTranslation extends Record {
    constructor(Translation) {
        super();
        this.Translation = Translation;
    }
}

export function TemplateTranslation$reflection() {
    return record_type("Containers.Invoicee.Model.TemplateTranslation", [], TemplateTranslation, () => [["Translation", option_type(string_type)]]);
}

export class File extends Record {
    constructor(Filename, InternalFilename, UploadedBy, Uploadedutc) {
        super();
        this.Filename = Filename;
        this.InternalFilename = InternalFilename;
        this.UploadedBy = UploadedBy;
        this.Uploadedutc = Uploadedutc;
    }
}

export function File$reflection() {
    return record_type("Containers.Invoicee.Model.File", [], File, () => [["Filename", string_type], ["InternalFilename", string_type], ["UploadedBy", string_type], ["Uploadedutc", string_type]]);
}

